import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import CheckIcon from '@wix/da-ds/pkg/Icons/24x24/Check';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { URLS } from '@wix/da-url';
import { DeviationResourceType } from '../../../types/deviation';
import s from './Subscribed.scss';
const SubscribedVariant = ({ tier , className , size ='medium' , href  })=>{
    const { t  } = useTranslation();
    const newSubscribeButtons = useFlag('subscribe_btns');
    return /*#__PURE__*/ React.createElement(SolidButton, {
        className: c(s['root'], className),
        size: size,
        variant: newSubscribeButtons ? 'main' : 'approval-green',
        icon: newSubscribeButtons ? CheckIcon : undefined,
        priority: "secondary",
        href: href,
        isFakeButton: !href,
        biData: {
            evid: BiEventType.TIER_UNSUBSCRIBE,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId,
            referral_info: (typeof window !== 'undefined' && window.location.href === URLS.ORDERS ? ReferralType.BILLING_PAYMENTS : ReferralType.TIER_CARD) || ReferralType.TIER_CARD
        }
    }, t('deviation.tier.subscribed'));
};
SubscribedVariant.displayName = 'SubscribedVariant';
export default SubscribedVariant;
